import React, {useState} from 'react';

const StartBox = ({start, setFirstMessage, ...props}) => {

  const closeOverlay = () => {
    document.querySelector('.ie-chatbot__toggle')?.click();
  };

  return (
    <div className="h-full flex flex-col justify-center items-center">
      <div className="ie-chat-window--start-box--content flex flex-col flex-wrap justify-center items-center">
        <h2 className="font-greed tracking-[-0.03em] uppercase mb-3 text-[60px] leading-[85%] lg:mb-6 lg:text-[4.8rem] lg:leading-[4rem] xl:text-[6.25rem] xl:leading-[5.438rem]">How can we help?</h2>
        <p className="md:display-h2 text-center max-w-[872px] mb-8">Not sure where to start? Use our AI-powered search bot to customise our content</p>
        <form className="w-full max-w-[664px] mx-0" onSubmit={() => start()}>
          <label for="start-chat" className="w-full flex justify-center text-center mb-2">I'm looking for</label>
          <div className="flex flex-row">
            <input placeholder="a website agency" className="border border-1 rounded-[50px] p-[10px] md:p-[15px] lg:p-[21px] !pr-[60px] md:!pr-[170px] grow bg-white/10" type="text" onChange={(e) => setFirstMessage(e.target.value)}/>
            <button id="start-chat" className="font-medium text-black md:text-xl lg:text-2xl p-[10px] md:p-[15px] lg:p-[21px] min-w-[46px] w-[46px] md:w-[175px] -ml-[46px] md:-ml-[150px] bg-white rounded-full md:rounded-[50px] cursor-pointer hover:bg-[#eee]">
              <span>SEARCH</span>
            </button>
          </div>
        </form>
        <div className="flex flex-col justify-center items-center">
          <button
            onClick={() => closeOverlay()}
            title="Hide the chat"
            type="button"
            className="mt-3 text-xl flex flex-row justify-center items-center gap-2"
            aria-label="Hide chatbot toggle"
          >
            <span className="relative z-10 flex h-[20px] w-[20px] rotate-45 items-center justify-center text-white">
              <span className="absolute left-0 top-1/2 h-[2px] w-full -translate-y-1/2 bg-white"></span>
              <span className="absolute left-1/2 top-0 h-full w-[2px] -translate-x-1/2 bg-white"></span>
            </span>
            Close
          </button>
        </div>
      </div>
    </div>
  );

};

export default StartBox;
